// 1. URL.parse() Polyfill for older WebKit (iOS 17.0 and earlier)
if (typeof URL.parse !== "function") {
  URL.parse = (url: string | URL, base?: string | URL) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

// 2. Promise.withResolvers() Polyfill for older iPads (iPadOS 17.3 and earlier)
if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
